/* global google */
import { prepareInfobox, domain } from "./utils";
import { moveTo, decodePolygon } from "../../maps/utils";
import Game from "./Game";
import { Map } from '../../maps';


class Puzzle extends Game {
  GAME_NAME = 'puzzle';
  CONGRATULATION = 'собрал пазл';
  CONGRATULATION_PLURAL = 'собрали пазл';
  HEADER = 'Пазл'
  CAPTION = 'Расставьте страны/регионы по своим местам.'

  static extractData(polygons, solved) {
    return polygons.map(country => {
      let paths = decodePolygon(country.polygon);
      paths = moveTo(
          paths,
          new google.maps.LatLng(country.center[1], country.center[0]),
          new google.maps.LatLng(country.default_position[1], country.default_position[0])
      );
      return {
        id: country.id,
        draggable: true,
        isSolved: false,
        infobox: {name: country.name, loaded: false},
        paths: Map.preparePolygon(paths, false)
      }
    }).concat(solved.map(region => {
      return {
        id: region.id,
        draggable: false,
        isSolved: true,
        infobox: region.infobox,
        paths: Map.preparePolygon(region.polygon)
      }
    })).sort((one, another) => {
      return one.infobox.name > another.infobox.name ? 1 : -1
    });
  }

  dispatchMessage = (event) => {
    let data = JSON.parse(event.data);
    let regions = this.state.regions;
    let infobox = this.state.infobox;
    switch(data.type) {
      case 'PUZZLE_CHECK_SUCCESS':
        regions = regions.map((region) => {
          if (region.id === data.id) {
            return {
              ...region,
              draggable: false,
              isSolved: true,
              infobox: {...prepareInfobox(data.infobox), loaded: true},
              paths: Map.preparePolygon(data.polygon),
            };
          } else {
            return region;
          }
        });
        infobox = data.infobox;
        break;
      case 'PUZZLE_GIVEUP_DONE':
        regions = regions.map((polygon) => {
          if (!polygon.isSolved) {
            let solve = data.solves[polygon.id];
            return {
              ...polygon,
              draggable: false,
              infobox: {...prepareInfobox(solve.infobox), loaded: true},
              paths: Map.preparePolygon(solve.polygon),
            };
          } else {
            return polygon;
          }
        });
        break;
    }
    this.setState({...this.state, regions: regions, infobox: infobox, giveUp: null}, () => {
      if (this.state.regions.length > 0 && this.state.regions.filter(el => el.isSolved === false).length === 0) {
        let time = new Date(Date.now() - this.state.startTime);
        this.showCongratulation(time.toLocaleTimeString('ru-RU', {timeZone: 'UTC'}));
      }
    });
  };

  loadData = () => {
    fetch(`${domain("http")}/puzzle/${this.props.slug}/questions/`, {mode: 'cors'})
      .then(response => response.json())
      .then(data => {
        this.startGame({regions: Puzzle.extractData(data.questions, data.solved)});
      })
      .catch(response => {
        this.setState({...this.state, isLoaded: false})
      });
  };

  onDragPolygon = (id, coords, path) => {
    this.wsSend({type: 'PUZZLE_CHECK', coords: coords, id: id, zoom: 4});
  };

  giveUp = () => {
    this.setState({...this.state, giveUp: true}, () => {
      let ids = this.state.regions.filter(obj => (!obj.isSolved)).map(polygon => (polygon.id));
      return this.wsSend({ids: ids, type: 'PUZZLE_GIVEUP'});
    });
  };
}

export default Puzzle;
